export default __webpack_public_path__ + "static/media/camera_icon.3627afb5.jpg";